import { translate } from 'utils/translation'

import { ServerErrorParams } from '../providers'

type ErrorCode =
  | 'generic_card_error'
  | 'transaction_declined'
  | 'generic_api_error'
  | 'api_request_timeout'
  | 'insufficient_funds'
  | 'active_subscription'
  | 'customer_not_found'

const ERROR_MESSAGE_TEXT: Record<ErrorCode, string> = {
  generic_card_error: 'card_error',
  transaction_declined: 'transaction_declined_error',
  generic_api_error: 'generic_api_error',
  api_request_timeout: 'api_request_timeout',
  insufficient_funds: 'insufficient_funds_error',
  active_subscription: 'found_active_subscription',
  customer_not_found: 'customer_not_found',
}

const isErrorCode = (code: string): code is ErrorCode => {
  return code in ERROR_MESSAGE_TEXT
}

export const getApiErrorText = (error: ServerErrorParams) => {
  if (!error) return ''
  const { code = '', message = '' } = error
  if (code && isErrorCode(code)) return translate(ERROR_MESSAGE_TEXT[code])
  return message
}
